<!-- <p>new-complaint works!</p> -->
<!-- <p>data-entry-complaint-form works!</p> -->
<app-spinner></app-spinner>
<div class="row">
  <div class="col-12" style="text-align: right; padding: 10px 20px;">
    <h4 class="dashboard cursor-pointer hover-blue" style="color: rgb(24, 107, 202);" (click)="back()" role="button">
      &lt; {{ translation.t('operatorNewComplaint','back') }} </h4>

  </div>
</div>
<div class="container-fluid">
  <div class="row" style="flex-shrink: 0;">
    <div class="col-12">
      <h3 class="complaint-submit">{{ translation.t('operatorNewComplaint','submitComplaintTitle') }}</h3>
      <p class="instruction" style="white-space: normal; word-wrap: break-word !important;">{{ translation.t('operatorNewComplaint','instruction') }}</p>
    </div>
  </div>
  <div class="row" style="height: fit-content;">
    <div class="col-12" style="height: fit-content;">
      <mat-card class="example-card px-2 my-3" appearance="outlined">
        <form [formGroup]="complaint_form" (ngSubmit)="onSubmit()">
          <div class="row pt-4">
            <div class="col-12 col-md-6 mb-3">
              <mat-label>{{ translation.t('operatorNewComplaint','fullName') }} <span style="color: red;">*</span></mat-label><br>
              <mat-form-field class="pt-1 w-100 common-field" appearance="outline">
                <input name="full_name" matInput (keypress)="allowOnlyKeysForName($event)" formControlName="full_name"
                  required [placeholder]="translation.t('operatorNewComplaint','enterFullName')" maxlength="250">
                <mat-error *ngIf="complaint_form.get('full_name')?.hasError('required')">
                  {{ translation.t('operatorNewComplaint','fullNameRequired') }}
                </mat-error>
                <mat-error *ngIf="complaint_form.get('full_name')?.hasError('pattern')">
                  {{ translation.t('operatorNewComplaint','fullNameInvalid') }}
                </mat-error>
                <mat-error
                  *ngIf="complaint_form.get('full_name')?.hasError('maxlength') && complaint_form.get('full_name')?.touched">
                  {{ translation.t('operatorNewComplaint','fullNameMax') }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-12 col-md-6 mb-3">
              <mat-label>{{ translation.t('operatorNewComplaint','mobileNumber') }} <span style="color: red;">*</span></mat-label><br>
              <mat-form-field class="pt-1 w-100 common-field" appearance="outline">
                <input name="mobile_no" matInput formControlName="mobile_no" (keypress)="allowOnlyKeysForMobile($event)"
                  required type="tel" [placeholder]="translation.t('operatorNewComplaint','enterMobileNo')" maxlength="10" />
                <mat-error *ngIf="complaint_form.get('mobile_no')?.hasError('invalidMobile')">
                  {{ translation.t('operatorNewComplaint','mobileInvalid') }}
                </mat-error>
                <mat-error *ngIf="complaint_form.get('mobile_no')?.hasError('pattern')">
                  {{ translation.t('operatorNewComplaint','mobileInvalid') }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row pt-4">
            <div class="col-12 col-md-6 mb-3">
              <mat-label>{{ translation.t('operatorNewComplaint','complaintDepartment') }}<span style="color: red;">*</span></mat-label>
              <mat-form-field appearance="outline" class="w-100" style="margin-top: 5px;">
                <mat-select name="dept" formControlName="dept" [placeholder]="translation.t('operatorNewComplaint','selectDepartment')"
                  (selectionChange)="onDepartmentChange($event.value)" required>
                  <mat-option *ngFor="let element of allDepartment" [value]="element.dep_cd">
                    {{element.department_name}}
                  </mat-option>
                </mat-select>
                <mat-error
                  *ngIf="complaint_form.get('dept')?.hasError('required') && complaint_form.get('dept')?.touched">
                  {{ translation.t('operatorNewComplaint','departmentRequired') }}
                </mat-error>
              </mat-form-field>
              <small *ngIf="complaint_form.get('dept')?.hasError('required') && !complaint_form.get('dept')?.touched">
                {{ translation.t('operatorNewComplaint','departmentRequired') }}
              </small>
            </div>

            <div class="col-12 col-md-6 mb-3">
              <mat-label>{{ translation.t('operatorNewComplaint','zone') }} <span style="color: red;">*</span></mat-label><br>
              <mat-form-field appearance="outline" class="w-100" style=" margin-bottom:-20px; margin-top: 5px;">
                <mat-select name="zone_leaf_cd" [placeholder]="translation.t('operatorNewComplaint','select')" formControlName="zone_leaf_cd" required>
                  <mat-option *ngFor="let element of zoneArr" [value]="element.zone_leaf_cd"
                    (click)="changeZone(element.zone_leaf_cd)">{{ element.zone}}</mat-option>
                </mat-select>
                <mat-error
                  *ngIf="complaint_form.get('zone_leaf_cd')?.hasError('required') && complaint_form.get('zone_leaf_cd')?.touched">
                  {{ translation.t('operatorNewComplaint','zoneRequired') }}
                </mat-error>
              </mat-form-field><br>
              <small
                *ngIf="complaint_form.get('zone_leaf_cd')?.hasError('required') && !complaint_form.get('zone_leaf_cd')?.touched">
                {{ translation.t('operatorNewComplaint','zoneRequired') }}
              </small>
            </div>
            
            <div class="col-12 col-md-6 mb-3">
              <mat-label>{{ translation.t('operatorNewComplaint','officerName') }} <span style="color: red;">*</span></mat-label><br>
              <mat-form-field appearance="outline" class="w-100" style="margin-top: 5px;">
                <mat-select name="officer" formControlName="resolver_user_id" [placeholder]="translation.t('operatorNewComplaint','select')">
                  <mat-option *ngFor="let element of resolverArr" [value]="element.user_id">{{ element.party_name }}
                    ({{element.role_cd}})</mat-option>
                </mat-select>
                <mat-error
                  *ngIf="complaint_form.get('resolver_user_id')?.hasError('required') && complaint_form.get('resolver_user_id')?.touched">
                  {{ translation.t('operatorNewComplaint','officerRequired') }}
                </mat-error>
              </mat-form-field>
              <small
                *ngIf="complaint_form.get('resolver_user_id')?.hasError('required') && !complaint_form.get('resolver_user_id')?.touched">
                {{ translation.t('operatorNewComplaint','officerRequired') }}
              </small>
            </div>
          </div>

          <mat-label>{{ translation.t('operatorNewComplaint','complaintDescription') }}<span style="color: red;">*</span><small>(0/500
              {{ translation.t('operatorNewComplaint','characters') }})</small></mat-label>
          <mat-form-field appearance="outline" class="full-width" style="width: 100%;">
            <textarea name="complaint_desc" matInput rows="4" formControlName="complaint_desc" required maxlength="500"
              [placeholder]="translation.t('operatorNewComplaint','complaintDescriptionPlaceholder')"></textarea>
            <mat-hint align="end">
              {{ complaint_form.get('complaint_desc')?.value?.length || 0 }}/500
            </mat-hint>
            <mat-error
              *ngIf="complaint_form.get('complaint_desc')?.hasError('required') && complaint_form.get('complaint_desc')?.touched">
              {{ translation.t('operatorNewComplaint','descriptionRequired') }}
            </mat-error>
            <mat-error
              *ngIf="complaint_form.get('complaint_desc')?.hasError('maxlength') && complaint_form.get('complaint_desc')?.touched">
              {{ translation.t('operatorNewComplaint','descriptionMax') }}
            </mat-error>
            <mat-error
              *ngIf="complaint_form.get('complaint_desc')?.hasError('leadingWhitespace') && complaint_form.get('complaint_desc')?.touched">
              {{ translation.t('operatorNewComplaint','descriptionNoLeadingSpace') }}
            </mat-error>
          </mat-form-field>
          <div style="display: flex; flex-direction: row; gap: 20px;" class="mt-5 form-row">
            <div class="w-50 file-field">
              <mat-label>{{ translation.t('operatorNewComplaint','uploadDocumentOptional') }}</mat-label>
              <!-- <mat-form-field appearance="outline" class="full-width" style="width: 100%; margin-bottom:-20px;"
                (click)="fileInput.click()"> -->
              <!-- <input matInput [value]="uploaded_fileName" formControlName="uploaded_fileName" readonly
                  placeholder="Upload" /> -->
              <input #comDocInput type="file" name="com_doc" id="mapFileInput" accept="application/pdf"
                (change)="checkFile($event,'com')" style="margin-top: 5px;" #fileInputl class="upload-box form-control"
                required />
              <p (click)="view('com')" class="text-right text-primary"
                style="text-decoration: underline; cursor: pointer;"
                *ngIf="selectedFileUrlObj['com'] &&  selectedFileUrlObj['com']['url']">{{ translation.t('operatorNewComplaint','clickHereToView') }} </p>
              <!-- <button mat-icon-button matSuffix aria-label="Upload file">
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                    <path
                      d="M12.5 5L13.2071 4.29289L12.5 3.58579L11.7929 4.29289L12.5 5ZM11.5 17C11.5 17.5523 11.9477 18 12.5 18C13.0523 18 13.5 17.5523 13.5 17L11.5 17ZM18.5 11L19.2071 10.2929L13.2071 4.29289L12.5 5L11.7929 5.70711L17.7929 11.7071L18.5 11ZM12.5 5L11.7929 4.29289L5.79289 10.2929L6.5 11L7.20711 11.7071L13.2071 5.70711L12.5 5ZM12.5 5L11.5 5L11.5 17L12.5 17L13.5 17L13.5 5L12.5 5Z"
                      fill="#33363F" />
                    <path d="M5.5 21L19.5 21" stroke="#33363F" stroke-width="2" />
                  </svg>
                </button> -->
              <!-- <input type="file" #fileInput style="display: none" /> -->
              <!-- </mat-form-field> -->
              <small>{{ translation.t('operatorNewComplaint','uploadNote') }}</small>
            </div>
            <div class="w-50 file-field">
              <mat-label>{{ translation.t('operatorNewComplaint','otherDocumentOptional') }}</mat-label>
              <!-- <mat-form-field appearance="outline" class="full-width" style="width: 100%;margin-bottom:-20px;"
                (click)="fileInput.click()">
                <input matInput [value]="uploaded_fileName" formControlName="uploaded_fileName" readonly
                  placeholder="Upload" />
                <button mat-icon-button matSuffix aria-label="Upload file">
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                    <path
                      d="M12.5 5L13.2071 4.29289L12.5 3.58579L11.7929 4.29289L12.5 5ZM11.5 17C11.5 17.5523 11.9477 18 12.5 18C13.0523 18 13.5 17.5523 13.5 17L11.5 17ZM18.5 11L19.2071 10.2929L13.2071 4.29289L12.5 5L11.7929 5.70711L17.7929 11.7071L18.5 11ZM12.5 5L11.7929 4.29289L5.79289 10.2929L6.5 11L7.20711 11.7071L13.2071 5.70711L12.5 5ZM12.5 5L11.5 5L11.5 17L12.5 17L13.5 17L13.5 5L12.5 5Z"
                      fill="#33363F" />
                    <path d="M5.5 21L19.5 21" stroke="#33363F" stroke-width="2" />
                  </svg>
                </button>
                <input type="file" #fileInput style="display: none" />
              </mat-form-field> -->
              <input name="invoiceFile" #othersDocInput type="file" id="mapFileInput" accept="application/pdf"
                (change)="checkFile($event,'others')" style="margin-top: 5px;" #fileInputl
                class="upload-box form-control" required />
              <p (click)="view('others')" class="text-right text-primary"
                style="text-decoration: underline; cursor: pointer;"
                *ngIf="selectedFileUrlObj['others'] &&  selectedFileUrlObj['others']['url']">{{ translation.t('operatorNewComplaint','clickHereToView') }} </p>
              <small>{{ translation.t('operatorNewComplaint','maxSize') }}</small>
            </div>

          </div>
          <br><br>
        </form>


        <form [formGroup]="intant_resolve_form" (ngSubmit)="onSubmit()" style="margin-bottom: 20px;">
          <div class="addextafieldcheckbox pt-2 ps-2 mt-4">
            <p class="resolution-status">{{ translation.t('operatorNewComplaint','instantResolutionDetails') }}</p>
            <mat-checkbox name="is_ressolve" formControlName="is_instant_resolved" style="margin-bottom: 30px;"
              (click)="showHiddenFields()">
              {{ translation.t('operatorNewComplaint','markResolvedInstantly') }} <br />
              <small>
                {{ translation.t('operatorNewComplaint','instantResolveNote1') }} <span
                  *ngIf="allEscalationRule[0] && allEscalationRule[0]['time'] ; else escalationRule"><b>{{allEscalationRule[0]['time']}}</b>
                  {{ translation.t('operatorNewComplaint','hours') }}</span> <ng-template #escalationRule><b>7</b> {{ translation.t('operatorNewComplaint','days') }}</ng-template>.
              </small>
            </mat-checkbox>
            <div *ngIf="is_instant_resolved" class="extra-fields mt-3">
              <div class="row form-row d-flex mt-5 px-2" style="justify-content: space-between;">
                <div class="col-6 common-field1" style="padding: 0; margin: 0;">
                  <mat-label>{{ translation.t('operatorNewComplaint','remark') }}<span style="color: red;">*</span><small>(0/500
                      {{ translation.t('operatorNewComplaint','characters') }})</small></mat-label>
                  <mat-form-field appearance="outline" class="full-width" style="width: 100%;">
                    <textarea name="remarks" matInput rows="4" formControlName="resolved_remark" required
                      [placeholder]="translation.t('operatorNewComplaint','remarkPlaceholder')" maxlength="500"
                      style="resize: vertical; word-wrap: break-word; overflow-wrap: break-word;"></textarea>

                    <mat-hint align="end">
                      {{ intant_resolve_form.get('resolved_remark')?.value?.length || 0 }}/500
                    </mat-hint>

                    <mat-error *ngIf="intant_resolve_form.get('resolved_remark')?.hasError('required') &&
                      intant_resolve_form.get('resolved_remark')?.touched">
                      {{ translation.t('operatorNewComplaint','remarkRequired') }}
                    </mat-error>

                    <mat-error *ngIf="intant_resolve_form.get('resolved_remark')?.hasError('maxlength') &&
                        intant_resolve_form.get('resolved_remark')?.touched">
                      {{ translation.t('operatorNewComplaint','remarkMax') }}
                    </mat-error>
                    <mat-error
                      *ngIf="intant_resolve_form.get('resolved_remark')?.hasError('leadingWhitespace') && intant_resolve_form.get('resolved_remark')?.touched">
                      {{ translation.t('operatorNewComplaint','remarkNoLeadingSpace') }}
                    </mat-error>
                  </mat-form-field>

                </div>
                <div class="col-6 common-field1" style="padding: 0; margin: 0; ">
                  <mat-label>{{ translation.t('operatorNewComplaint','approvalDescription') }}<span style="color: red; padding: 0; margin: 0;">*</span><small>(0/500
                      {{ translation.t('operatorNewComplaint','characters') }})</small></mat-label>
                  <mat-form-field appearance="outline" class="full-width" style="width: 100%; height: 150px;">
                    <textarea name="approval" matInput rows="4" formControlName="approval_desc" required
                      [placeholder]="translation.t('operatorNewComplaint','remarkPlaceholder')" maxlength="500"
                      style="resize: vertical; word-wrap: break-word; overflow-wrap: break-word;"></textarea>
                    <mat-hint align="end">
                      {{ intant_resolve_form.get('approval_desc')?.value?.length || 0 }}/500
                    </mat-hint>

                    <mat-error *ngIf="intant_resolve_form.get('approval_desc')?.hasError('required') &&
                      intant_resolve_form.get('approval_desc')?.touched">
                      {{ translation.t('operatorNewComplaint','approvalRequired') }}
                    </mat-error>

                    <mat-error *ngIf="intant_resolve_form.get('approval_desc')?.hasError('maxlength') &&
                        intant_resolve_form.get('approval_desc')?.touched">
                      {{ translation.t('operatorNewComplaint','approvalMax') }}
                    </mat-error>
                    <mat-error
                      *ngIf="intant_resolve_form.get('approval_desc')?.hasError('leadingWhitespace') && intant_resolve_form.get('approval_desc')?.touched">
                      {{ translation.t('operatorNewComplaint','approvalNoLeadingSpace') }}
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <mat-label>{{ translation.t('operatorNewComplaint','uploadImageOrDocumentOptional') }}</mat-label>
              <input name="invoiceFile" #resolvedDocInput type="file" id="mapFileInput" accept="application/pdf"
                (change)="checkFile($event,'resolved')" style="margin-top: 5px;" #fileInputl
                class="upload-box form-control" required />
              <p (click)="view('resolved')" class="text-right text-primary"
                style="text-decoration: underline; cursor: pointer;"
                *ngIf="selectedFileUrlObj['resolved'] &&  selectedFileUrlObj['resolved']['url']">{{ translation.t('operatorNewComplaint','clickHereToView') }} </p>
              <!-- <mat-form-field appearance="outline" class="full-width" style="width: 100%; margin-bottom:-20px;"
                (click)="fileInput.click()">
                <input matInput [value]="uploaded_fileName" formControlName="uploaded_fileName" readonly />
                <button mat-icon-button matSuffix aria-label="Upload file">
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                    <path
                      d="M12.5 5L13.2071 4.29289L12.5 3.58579L11.7929 4.29289L12.5 5ZM11.5 17C11.5 17.5523 11.9477 18 12.5 18C13.0523 18 13.5 17.5523 13.5 17L11.5 17ZM18.5 11L19.2071 10.2929L13.2071 4.29289L12.5 5L11.7929 5.70711L17.7929 11.7071L18.5 11ZM12.5 5L11.7929 4.29289L5.79289 10.2929L6.5 11L7.20711 11.7071L13.2071 5.70711L12.5 5ZM12.5 5L11.5 5L11.5 17L12.5 17L13.5 17L13.5 5L12.5 5Z"
                      fill="#33363F" />
                    <path d="M5.5 21L19.5 21" stroke="#33363F" stroke-width="2" />
                  </svg>
                </button>
                <input type="file" #fileInput style="display: none" placeholder="Upload" />
              </mat-form-field> -->
              <small>{{ translation.t('operatorNewComplaint','maxSize') }}</small>
              <div class="text-center mt-5">
                <button style="background-color: #226CE0; color: white; text-align: center;" mat-raised-button>{{ translation.t('operatorNewComplaint','submitComplaint') }}</button>
              </div>
            </div>
            <div class="text-center mt-2 mt-md-5" *ngIf="!is_instant_resolved">
              <button style="background-color: #226CE0; color: white; text-align: center;" mat-raised-button>
                {{ translation.t('operatorNewComplaint','submitComplaint') }}
              </button>
            </div>
          </div>
        </form>
      </mat-card>
    </div>
  </div>
</div>
